import styled from 'styled-components';
import { Title } from '@minerva-analytics/pantheon';
import { PEARL, WHITE, BLACK, HONEY, LARGE, MOBILE } from '../../theme';

const theme = {
  ghostAuthor: `
    text-transform: uppercase; 
    letter-spacing: 1.1px; 
    font-weight: 500; 
    font-family: 'Oswald', sans-serif; 
    font-size: 1rem; 
    line-height: 1.5rem; 
  `,
  ghostReadTime: `
    text-transform: uppercase; 
    letter-spacing: 1.3px; 
    font-size: 1.125rem;
    font-weight: 700; 
    font-family: 'Oswald', sans-serif;
    line-height: 1.6rem;
  `,
  ghostViewMore: `
    :before { 
      content: " "; 
      border-bottom: solid 2px ${HONEY}; 
      width: 9.75rem; 
      bottom: 0; 
      position:absolute; 
      @media (max-width: ${MOBILE}){
        width: 8.5rem;
      }
    }; 
    margin-bottom: 0;
  `,
  SubTitle: `
    &&&{
      color: ${BLACK};
      font-size: 1.5rem; 
      line-height: 1.8rem; 
    }
  `,
  Image: `
    background-color: ${WHITE};
  `,
  ghostFeaturedImage: `
    &&&{
      background-color: ${PEARL};
    }
  `,
  ghostFeaturedAuthor: `
    color: ${WHITE};
  `,
  ghostFeaturedPublished: `
    color: ${WHITE};
  `,
};

const ArticlesContainer = styled.div`
  background-color: ${PEARL};
  height: 100%;
  min-height: 100vh;
  padding-bottom: 6rem;
`;

const Header = styled.div`
  background-color: ${BLACK};
  padding: 2rem 0;
  text-align: center;
  position: relative;
  display: flex;
  @media (max-width: ${MOBILE}) {
    padding: 2rem 0 0 0;
  }
`;

const HeaderWrapper = styled.div`
  display: inline-block;
  margin: 0 auto;
  position: relative;

  @media (max-width: ${MOBILE}) {
    margin: unset;
    padding-left: 2rem;
  }
`;

const HeaderText = styled(Title)`
  color: ${WHITE};
  position: relative;
  z-index: 10;
  margin: 0 auto;
  align-items: center;
  @media (max-width: ${LARGE}) {
    max-width: 500px;
  }

  @media (max-width: ${MOBILE}) {
    text-align: left;
    margin: unset;
    max-width: 300px;
  }
`;

const ScribbleImage = styled.img`
  z-index: 1;
  position: absolute;
  height: 5.625rem;
  width: auto;
  top: -0.2rem;
  right: -6.5rem;

  @media (max-width: ${LARGE}) {
    top: 3rem;
    right: -2.8rem;
  }

  @media (max-width: ${MOBILE}) {
    top: 2rem;
    right: 1rem;
    height: 90%;
  }
`;

export {
  theme,
  ArticlesContainer,
  Header,
  HeaderText,
  ScribbleImage,
  HeaderWrapper,
};
